import { NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import { classNames } from "../../helpers/classNames";

const SidebarMenuItem = ({
  menuLink,
  menuIconColor,
  menuIcon,
  menuLabel,
  isMenuOpen,
  icon,
  blank = false,
}) => {
  const location = useLocation();
  const isExternal = menuLink?.startsWith("http");

  if (isExternal) {
    return (
      <a
        href={menuLink}
        target="_blank"
        rel="noopener noreferrer"
        className={({ isActive }) => {
          const isExactMatch =
            menuLink === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(menuLink);
          return classNames(
            "group text-sm flex items-center gap-1 group hover:text-white hover:bg-chestnut-rose rounded overflow-hidden p-1 transition-all duration-200",
            isExactMatch ? " !bg-chestnut-rose" : "",
            isActive ? "text-white" : "text-gable-green"
          );
        }}
      >
        <>
          <div
            className={() => {
              const isExactMatch =
                menuLink === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(menuLink);
              return classNames(
                "w-8 h-8 flex justify-center items-center text-sm transition-all duration-200 group-hover:!text-white ",
                menuIconColor,
                isExactMatch ? " !text-white" : ""
              );
            }}
          >
            <i className={classNames("fa-fw text-base", menuIcon)}></i>
          </div>
          {!isMenuOpen && <div>{menuLabel}</div>}
        </>
      </a>
    );
  }

  return (
    <NavLink
      to={menuLink}
      {...(blank && { target: "_blank" })}
      className={({ isActive }) => {
        const isExactMatch =
          menuLink === "/"
            ? location.pathname === "/"
            : location.pathname.startsWith(menuLink);
        return classNames(
          "group text-sm flex items-center gap-1 group hover:text-white hover:bg-chestnut-rose rounded overflow-hidden p-1 transition-all duration-200",
          isExactMatch ? " !bg-chestnut-rose" : "",
          isActive ? "text-white" : "text-gable-green"
        );
      }}
    >
      {({ isActive }) => {
        const isExactMatch =
          menuLink === "/"
            ? location.pathname === "/"
            : location.pathname.startsWith(menuLink);
        return (
          <>
            <div
              className={classNames(
                "w-8 h-8 flex justify-center items-center text-sm transition-all duration-200 group-hover:!text-white ",
                menuIconColor,
                isExactMatch ? " !text-white" : ""
              )}
            >
              <i className={classNames("fa-fw text-base", menuIcon)}></i>
            </div>
            {/* {!isMenuOpen && <div>{menuLabel}</div>} */}
            <div>{menuLabel}</div>
          </>
        );
      }}
    </NavLink>
  );
};

export default SidebarMenuItem;
